import React, { useState } from "react";
import { Button, Fade, Paper, Stack, Typography } from "@mui/material";
import TrapFocus from "@mui/material/Unstable_TrapFocus";
import { useTranslation } from "react-i18next";

export const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const [bannerOpen, setBannerOpen] = useState(true);

  const closeBanner = () => {
    setBannerOpen(false);
  };

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    closeBanner();
  };

  const rejectCookies = () => {
    localStorage.setItem("cookiesAccepted", "false");
    closeBanner();
  };

  if (localStorage.getItem("cookiesAccepted")) {
    return null;
  }

  return (
    <TrapFocus open disableAutoFocus disableEnforceFocus>
      <Fade appear={false} in={bannerOpen}>
        <Paper
          role="dialog"
          aria-modal="false"
          aria-label="Cookie banner"
          square
          variant="outlined"
          tabIndex={-1}
          sx={{
            width: 500,
            position: "fixed",
            bottom: 10,
            right: 10,
            padding: 2,
            border: 2,
            borderColor: "secondary.main",
            borderRadius: 2,
            zIndex: 9,
          }}
        >
          <Stack direction="column" justifyContent="flex-start" gap={2}>
            <Typography variant="h5" color="textSecondary">
              {t("cookie.title")}
            </Typography>

            <Typography variant="body2" color="textSecondary">
              {t("cookie.body")}
            </Typography>

            <Button size="small" onClick={acceptCookies} variant="contained">
              {t("cookie.accept")}
            </Button>
            <Button size="small" onClick={rejectCookies} variant="contained">
              {t("cookie.reject")}
            </Button>
          </Stack>
        </Paper>
      </Fade>
    </TrapFocus>
  );
};
